module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-1-3-34c467be17c39bd7c2da91f5499aa7c2.jpg";